<template>
    <article class="link-preview">
        <section class="link-preview__body">
            <img
                v-if="resource.image"
                :src="resource.image" :alt="`${resource.title} Preview image`"
                class="link-preview__image"
            />
            <div class="link-preview__content">
                <a :href="resource.url" target="_blank" class="link-preview__title">{{ resource.title }}</a>
                <SvgIcon icon="link" class="link-preview__icon"/>
                <p v-if="resource.description" v-text="resource.description"  class="link-preview__description" />
            </div>
        </section>
        <footer class="link-preview__footer" v-if="resource.url">
            <a target="_blank" :href="resource.url">{{ resource.url }}</a>
        </footer>
    </article>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'SectorPostCardLink',
    components: {SvgIcon},
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "~@/theme/_variables.scss";

    .link-preview {
        border: 1px solid $border;
        border-radius: 4px;
        width: 100%;

        .link-preview__body {
            display: flex;
            align-items: flex-start;
            padding: 1rem;
            column-gap: 1rem;
        }

        .link-preview__image {
            flex: 0 0 9rem;
            max-width: 9rem;
            border-radius: .2rem;
            overflow: hidden;
            aspect-ratio: 1 / 1;
        }

        .link-preview__content {
            display: flex;
            align-items: flex-start;
            gap: .4rem;
            flex-wrap: wrap;

            .link-preview__title {
                flex: 1 1 auto;
                font-size: 1.4rem;
                font-weight: 500;
                max-width: calc(100% - 2rem);
            }

            .link-preview__icon {
                flex: 0 0 1.6rem;
                margin-right: 0;
            }

            .link-preview__description {
                color: $text;
                margin: 0;
                flex: 1 0 100%;
                font-size: 1.2rem;
            }
        }

        .link-preview__footer {
            border-top: .1rem solid $border;
            padding: .5rem 1rem;
            font-size: 1.2rem;
        }
    }
</style>
